import React, { useState, useEffect } from 'react';
import { CardMedia } from '@mui/material';

const AdaptiveImage = ({ imageId, imageUrl: providedImageUrl, ...props }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

  useEffect(() => {
    // If direct URL is provided, use it
    if (providedImageUrl) {
      // Check if it's already a full URL
      if (providedImageUrl.startsWith('http')) {
        setImageUrl(providedImageUrl);
      } else {
        setImageUrl(`${API_BASE_URL}${providedImageUrl}`);
      }
      return;
    }

    // Otherwise try to load image by ID
    const tryLoadImage = async () => {
      // Try JPG first
      const jpgUrl = `${API_BASE_URL}/images/${imageId}.jpg`;
      try {
        const jpgResponse = await fetch(jpgUrl, { method: 'HEAD' });
        if (jpgResponse.ok) {
          setImageUrl(jpgUrl);
          return;
        }
      } catch (e) {
        // Ignore error and try PNG
      }

      // Try PNG if JPG failed
      const pngUrl = `${API_BASE_URL}/images/${imageId}.png`;
      try {
        const pngResponse = await fetch(pngUrl, { method: 'HEAD' });
        if (pngResponse.ok) {
          setImageUrl(pngUrl);
          return;
        }
      } catch (e) {
        // Both formats failed
        console.error('Failed to load image in any format');
      }
    };

    if (imageId) {
      tryLoadImage();
    }
  }, [imageId, providedImageUrl, API_BASE_URL]);

  if (!imageUrl) {
    return null;
  }

  return (
    <CardMedia
      component="img"
      image={imageUrl}
      {...props}
    />
  );
};

export default AdaptiveImage; 